import React from "react";

/**
 * Tab bar for the Settings page. Presentational only - the active tab lives in
 * Settings.js so a deep link (?tab=games) and the panels stay in sync.
 */
const TABS = [
  { key: "general", label: "General" },
  { key: "games", label: "Games" },
  { key: "wallet", label: "Wallet" },
  { key: "notes", label: "Notes" },
  { key: "history", label: "History" },
];

export default function SettingsTabs({ active, onChange }) {
  const handleKeyDown = (e, index) => {
    if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
    e.preventDefault();
    const dir = e.key === "ArrowRight" ? 1 : -1;
    const next = (index + dir + TABS.length) % TABS.length;
    onChange(TABS[next].key);
  };

  return (
    <div className="settings-tabs" role="tablist" aria-label="Settings sections">
      {TABS.map((tab, index) => {
        const isActive = active === tab.key;
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            id={`settings-tab-${tab.key}`}
            aria-selected={isActive}
            aria-controls={`settings-panel-${tab.key}`}
            tabIndex={isActive ? 0 : -1}
            className={`settings-tab${isActive ? " is-active" : ""}`}
            onClick={() => onChange(tab.key)}
            onKeyDown={(e) => handleKeyDown(e, index)}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}

export { TABS };
